// Contingut central del lloc Orbis Forum Català (en català)

export const IMAGES = {
  heroHome: "https://images.unsplash.com/photo-1612283157924-f0e11f121c3f?auto=format&fit=crop&w=2000&q=80",
  skyline: "https://images.pexels.com/photos/15882097/pexels-photo-15882097.jpeg?auto=compress&cs=tinysrgb&w=1800",
  skyscraper: "https://images.pexels.com/photos/21581764/pexels-photo-21581764.jpeg?auto=compress&cs=tinysrgb&w=1800",
  executive: "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?auto=format&fit=crop&w=1800&q=80",
  aviation: "https://images.unsplash.com/photo-1474302770737-173ee21bab63?auto=format&fit=crop&w=1800&q=80",
  maritime: "https://images.unsplash.com/photo-1718314740490-1463a6152cdd?auto=format&fit=crop&w=1800&q=80",
  globe: "https://images.unsplash.com/photo-1531266752426-aad472b7bbf4?auto=format&fit=crop&w=1800&q=80",
  documents: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1800&q=80",
  realestate: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1800&q=80",
  meeting: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=1800&q=80",
};

export const QUISOM_TEAM_IMG = "https://static.prod-images.emergentagent.com/jobs/c287c074-9c17-4a33-a8c6-97638ad368e7/images/4b2cae1517f6a2e7c5237d7d1d26a43f5f29f7b1bfeddc298643e12006de12c5.png";
export const MISSION_MAP_IMG = "https://emergent-prod-images.s3.us-east-1.amazonaws.com/jobs/c287c074-9c17-4a33-a8c6-97638ad368e7/images/54b7bb0530e9be72c3bd99e971b56f7b4abdc742c2fbd3ba37e88238e21c1c1b.png";
export const CONTACT_BG_IMG = "https://static.prod-images.emergentagent.com/jobs/c287c074-9c17-4a33-a8c6-97638ad368e7/images/64da1466246b1977b777c88a630b71674ae0e4070177132e646d52868a628aa4.png";

export const NAV = [
  { label: "Inici", path: "/" },
  { label: "Qui som", path: "/qui-som" },
  { label: "Serveis", path: "/serveis" },
  { label: "Casos il·lustratius", path: "/casos-illustratius" },
  { label: "Contacte", path: "/contacte" },
];

// Logotip oficial (fons ajustat al color de la web). No modificar; respectar proporcions.
export const LOGO_URL = "/logo/orbis-logo.png";

export const VALUES = [
  { title: "Discreció", text: "Tractem cada relació amb la màxima confidencialitat. La reserva és el fonament de la confiança." },
  { title: "Rigor", text: "Cada projecte s'aborda amb precisió, mètode i una anàlisi profunda del context internacional." },
  { title: "Projecció", text: "Acompanyem els interessos catalans més enllà de les fronteres, amb una mirada global i estratègica." },
  { title: "Independència", text: "Firma privada i autònoma. La nostra lleialtat és exclusivament amb qui confia en nosaltres." },
];

export const PROCESS = [
  { step: "01", title: "Escolta", text: "Analitzem la vostra situació, objectius i el context internacional del projecte amb absoluta reserva." },
  { step: "02", title: "Estratègia", text: "Dissenyem un pla d'actuació a mida, amb etapes clares i una avaluació realista dels riscos." },
  { step: "03", title: "Execució", text: "Coordinem la documentació, els interlocutors i els tràmits necessaris arreu del món." },
  { step: "04", title: "Acompanyament", text: "Mantenim un seguiment continu i discret fins a la consecució dels objectius acordats." },
];

export const SERVICES = [
  {
    slug: "assessorament-diplomatic",
    title: "Assessorament diplomàtic",
    short: "Orientació estratègica en entorns institucionals i relacions internacionals.",
    image: "https://static.prod-images.emergentagent.com/jobs/c287c074-9c17-4a33-a8c6-97638ad368e7/images/5dd817f6d5836b6181323e8a0636bcc32f9cca9d7bd84ec6097b5f9125f58973.png",
    intro: [
      "Oferim assessorament especialitzat a particulars i empreses catalanes que necessiten desenvolupar-se en entorns institucionals complexos i relacions internacionals sensibles.",
      "Analitzem el context geopolític, identifiquem els interlocutors adequats i preparem cada gestió amb la reserva i el rigor propis d'una firma privada d'alt nivell.",
    ],
    benefits: [
      "Lectura precisa del context institucional internacional.",
      "Preparació d'interlocucions i protocols amb discreció.",
      "Reducció de riscos en negociacions delicades.",
      "Acompanyament confidencial en tot el procés.",
    ],
    faq: [
      { q: "A qui s'adreça aquest servei?", a: "Exclusivament a ciutadans catalans i empreses registrades a Catalunya amb interessos o projectes en l'àmbit internacional." },
      { q: "Garantiu la confidencialitat?", a: "Sí. Tota la informació es tracta amb la màxima reserva i únicament amb les persones estrictament necessàries." },
    ],
  },
  {
    slug: "inversio-privada-internacional",
    title: "Inversió privada internacional",
    short: "Estructuració i acompanyament d'inversions en mercats internacionals.",
    image: IMAGES.skyscraper,
    intro: [
      "Acompanyem inversors catalans en la identificació, l'anàlisi i l'estructuració d'oportunitats d'inversió en mercats internacionals.",
      "El nostre paper és el d'un assessor privat i independent que vetlla pels vostres interessos amb objectivitat i discreció.",
    ],
    benefits: [
      "Anàlisi rigorosa d'oportunitats i riscos.",
      "Estructuració adaptada al vostre perfil.",
      "Xarxa internacional de contactes de confiança.",
      "Seguiment discret i continuat de les operacions.",
    ],
    faq: [
      { q: "Gestioneu directament els fons?", a: "No. Actuem com a assessors independents; la titularitat i la decisió sempre són del client." },
      { q: "Quins mercats cobriu?", a: "Treballem amb una orientació internacional àmplia, adaptant-nos a cada projecte concret." },
    ],
  },
  {
    slug: "importacio-exportacio",
    title: "Importació i exportació",
    short: "Assessorament en comerç internacional i operacions transfrontereres.",
    image: "https://static.prod-images.emergentagent.com/jobs/c287c074-9c17-4a33-a8c6-97638ad368e7/images/6b9594ba62115e8f566b7f12a64754fca47571f162dd3a284b7ba0a0efa93db2.png",
    intro: [
      "Assessorem empreses catalanes en les seves operacions de comerç internacional, des de la planificació logística fins a la documentació duanera.",
      "Facilitem l'obertura de nous mercats amb un enfocament pràctic, rigorós i orientat a resultats sostenibles.",
    ],
    benefits: [
      "Planificació d'operacions d'importació i exportació.",
      "Assessorament en documentació i normativa duanera.",
      "Identificació de socis comercials fiables.",
      "Optimització de rutes i cadenes logístiques.",
    ],
    faq: [
      { q: "Us encarregueu de la logística física?", a: "Coordinem els interlocutors adequats, però la nostra funció principal és l'assessorament i la supervisió estratègica." },
      { q: "Podeu ajudar amb nous mercats?", a: "Sí. Analitzem la viabilitat i acompanyem l'entrada a mercats internacionals de manera ordenada." },
    ],
  },
  {
    slug: "documentacio-legal",
    title: "Documentació legal",
    short: "Preparació i gestió de documentació per a projectes internacionals.",
    image: "https://static.prod-images.emergentagent.com/jobs/c287c074-9c17-4a33-a8c6-97638ad368e7/images/e9668ba7fdb24e39514c8c9ada923959653c8aec1e9a20da680203a0474cc558.png",
    intro: [
      "Coordinem la preparació, revisió i legalització de la documentació necessària per als vostres projectes internacionals.",
      "Treballem amb professionals qualificats per garantir que cada document compleix els requisits formals de cada jurisdicció.",
    ],
    benefits: [
      "Revisió i preparació documental acurada.",
      "Coordinació de legalitzacions i traduccions.",
      "Compliment dels requisits formals internacionals.",
      "Gestió ordenada i traçable de cada expedient.",
    ],
    faq: [
      { q: "Sou un despatx d'advocats?", a: "No. Som una consultora privada que coordina i supervisa la documentació amb professionals qualificats." },
      { q: "Podeu gestionar legalitzacions a l'estranger?", a: "Sí, coordinem els tràmits de legalització i apostilla segons cada cas." },
    ],
  },
  {
    slug: "visats-professionals",
    title: "Visats professionals",
    short: "Acompanyament en tràmits de mobilitat professional internacional.",
    image: "https://static.prod-images.emergentagent.com/jobs/c287c074-9c17-4a33-a8c6-97638ad368e7/images/142d83b0b8b4a4d1d1bc34988d3a028fc741c77e9fda3eb3e1280d3f541d85f2.png",
    intro: [
      "Acompanyem professionals i empreses catalanes en els tràmits de mobilitat internacional i l'obtenció de visats professionals.",
      "Simplifiquem un procés sovint complex, amb una gestió ordenada i un seguiment personalitzat de cada expedient.",
    ],
    benefits: [
      "Anàlisi de requisits per destinació i perfil.",
      "Preparació i revisió de la documentació.",
      "Seguiment personalitzat de cada tràmit.",
      "Reducció de terminis i incidències.",
    ],
    faq: [
      { q: "Garantiu l'obtenció del visat?", a: "Cap firma pot garantir la decisió d'una autoritat; sí garantim rigor, preparació i seguiment òptims." },
      { q: "Treballeu amb qualsevol destinació?", a: "Adaptem el servei a cada país de destinació segons les seves exigències." },
    ],
  },
  {
    slug: "inversio-immobiliaria-internacional",
    title: "Inversió immobiliària internacional",
    short: "Assessorament en adquisicions immobiliàries fora del territori nacional.",
    image: "https://static.prod-images.emergentagent.com/jobs/c287c074-9c17-4a33-a8c6-97638ad368e7/images/9c278a3014f84d742db88b1a9e227f6d0ba350232a35dc0d1da1efaf775eaa77.png",
    intro: [
      "Assessorem particulars i empreses catalanes en l'adquisició i la gestió d'actius immobiliaris en mercats internacionals.",
      "Aportem anàlisi, discreció i una xarxa de contactes que permet abordar cada operació amb garanties.",
    ],
    benefits: [
      "Selecció i anàlisi d'oportunitats immobiliàries.",
      "Due diligence i avaluació de riscos.",
      "Coordinació de la documentació de compra.",
      "Acompanyament fins a la formalització.",
    ],
    faq: [
      { q: "Sou una agència immobiliària?", a: "No. Actuem com a assessors independents que defensen exclusivament els interessos del client." },
      { q: "Podeu ajudar en la gestió posterior?", a: "Sí, oferim acompanyament en la gestió i supervisió de l'actiu adquirit." },
    ],
  },
  {
    slug: "expansio-global",
    title: "Expansió global",
    short: "Estratègia i acompanyament en la internacionalització d'empreses.",
    image: "https://static.prod-images.emergentagent.com/jobs/c287c074-9c17-4a33-a8c6-97638ad368e7/images/0eb478987f5cc327fb04b406f47e2a691fbdec139243d3b17639ab5c06a7d7b7.png",
    intro: [
      "Dissenyem i acompanyem estratègies d'internacionalització per a empreses catalanes que volen créixer en nous mercats.",
      "Del diagnòstic inicial a l'establiment operatiu, estructurem cada etapa amb mètode i visió a llarg termini.",
    ],
    benefits: [
      "Diagnòstic de potencial internacional.",
      "Full de ruta d'expansió a mida.",
      "Identificació de socis i canals locals.",
      "Acompanyament durant la implantació.",
    ],
    faq: [
      { q: "En quina fase podeu intervenir?", a: "Tant en fases inicials d'exploració com en processos d'implantació ja en marxa." },
      { q: "Treballeu amb pimes?", a: "Sí. Adaptem la nostra metodologia a la dimensió i els objectius de cada empresa." },
    ],
  },
  {
    slug: "assistencia-expatriats-catalans",
    title: "Assistència a expatriats catalans",
    short: "Suport integral a ciutadans catalans residents a l'estranger.",
    image: "https://static.prod-images.emergentagent.com/jobs/c287c074-9c17-4a33-a8c6-97638ad368e7/images/94bfb9fd88dd8868dc2d69834d6ab35ef6a61d7123e1765ad5ee7684ad24a1f6.png",
    intro: [
      "Oferim suport integral als ciutadans catalans que resideixen o es traslladen a l'estranger, tant en l'àmbit personal com professional.",
      "Un interlocutor de confiança que facilita la vida quotidiana i la gestió d'imprevistos lluny de casa.",
    ],
    benefits: [
      "Suport en la instal·lació i els tràmits inicials.",
      "Assistència en gestions administratives.",
      "Interlocució de confiança en cas d'imprevist.",
      "Acompanyament continu i personalitzat.",
    ],
    faq: [
      { q: "Cal residir ja a l'estranger?", a: "No. Acompanyem tant durant la preparació del trasllat com un cop instal·lats." },
      { q: "El servei és continuat?", a: "Sí, oferim un acompanyament sostingut en el temps segons les vostres necessitats." },
    ],
  },
];

// Imatges de la graella de serveis NOMÉS a la pàgina principal (no afecta les subpàgines).
const IMG_BASE = "https://static.prod-images.emergentagent.com/jobs/c287c074-9c17-4a33-a8c6-97638ad368e7/images/";
export const HOME_SERVICE_IMAGES = {
  "assessorament-diplomatic": IMG_BASE + "5dd817f6d5836b6181323e8a0636bcc32f9cca9d7bd84ec6097b5f9125f58973.png",
  "inversio-privada-internacional": IMG_BASE + "b5e24660aea40981c4c02526c379618dec8e14dbc12dabb878bd4c8c9a6e0cda.png",
  "importacio-exportacio": IMG_BASE + "6b9594ba62115e8f566b7f12a64754fca47571f162dd3a284b7ba0a0efa93db2.png",
  "documentacio-legal": IMG_BASE + "ebe8a7f270f8012a9e8a39ea9557e9bfa992c31f08c49c2578105f15e3c2b07b.png",
  "visats-professionals": IMG_BASE + "bdd6fd7f911fa39cd60fbaf6fd12defe12f1681b992fdeb2a7d48adf76d64fc7.png",
  "inversio-immobiliaria-internacional": IMG_BASE + "49dad5503759c0818182ec794be0a30bc1f5bf41dc3f7fdeafe07f1cae7bcc84.png",
  "expansio-global": IMG_BASE + "0eb478987f5cc327fb04b406f47e2a691fbdec139243d3b17639ab5c06a7d7b7.png",
  "assistencia-expatriats-catalans": IMG_BASE + "94bfb9fd88dd8868dc2d69834d6ab35ef6a61d7123e1765ad5ee7684ad24a1f6.png",
};

export const CASES = [
  {
    title: "Expansió d'una empresa industrial catalana",
    context: "Una empresa registrada a Catalunya vol obrir mercat en tres països diferents.",
    approach: "Diagnòstic de viabilitat, full de ruta per fases i identificació de socis locals de confiança.",
    tag: "Expansió global",
  },
  {
    title: "Adquisició immobiliària a l'estranger",
    context: "Un particular català considera invertir en un actiu immobiliari fora del territori nacional.",
    approach: "Anàlisi de l'operació, due diligence i coordinació de la documentació fins a la formalització.",
    tag: "Inversió immobiliària",
  },
  {
    title: "Mobilitat professional internacional",
    context: "Un professional català ha de traslladar-se temporalment a un altre país per motius laborals.",
    approach: "Anàlisi de requisits, preparació documental i seguiment personalitzat del tràmit de visat.",
    tag: "Visats professionals",
  },
  {
    title: "Operativa de comerç internacional",
    context: "Una pime catalana vol iniciar operacions regulars d'importació i exportació.",
    approach: "Planificació logística, assessorament duaner i selecció de socis comercials fiables.",
    tag: "Importació i exportació",
  },
  {
    title: "Estructuració d'una inversió internacional",
    context: "Un inversor català busca diversificar el seu patrimoni en mercats internacionals.",
    approach: "Anàlisi d'oportunitats, avaluació de riscos i estructuració adaptada al seu perfil.",
    tag: "Inversió privada",
  },
  {
    title: "Acompanyament a un ciutadà expatriat",
    context: "Una família catalana s'estableix de manera temporal en una capital internacional.",
    approach: "Suport en la instal·lació, gestions administratives i interlocució de confiança permanent.",
    tag: "Assistència a expatriats",
  },
];


export const TEAM_LEAD = {
  name: "Daniel Serralta",
  role: "Coordinador general · Operations Manager",
  location: "Catalunya",
  image: "/team/daniel.jpg",
  bio: "En Daniel lidera la coordinació general i les operacions de la firma des de Catalunya. Vetlla perquè cada projecte s'executi amb rigor, discreció i una visió estratègica internacional, coordinant la xarxa d'assessors arreu del món.",
};

export const TEAM_ADVISORS = [
  { name: "Michael Ceallaigh", role: "Assessor per a Europa", location: "Regne Unit", image: "/team/michael.jpg" },
  { name: "Helen Hamutenya", role: "Assessora per a l'Àfrica Meridional", location: "Namíbia", image: "/team/helen.jpg" },
  { name: "Bonipahace Otieno", role: "Assessor per a l'Àfrica Oriental", location: "Tanzània", image: "/team/boniphace.jpg" },
  { name: "Sarah Tamaki", role: "Assessora per a l'Extrem Orient", location: "Japó", image: "/team/sarah.jpg" },
  { name: "José Luis Xochitl Hernández", role: "Assessor per a Amèrica Central", location: "Mèxic", image: "/team/joseluis.jpg" },
];
